module.exports = function() {
  return new Worker(__webpack_public_path__ + "e703c1e2d312099e5540.worker.js");
};